import React from "react";
import { Box, Button, Typography } from "@mui/material";

interface Props {
  children: React.ReactNode;
}

interface State {
  hasError: boolean;
}

/**
 * Catches render-time errors so a single failure shows a recoverable message instead of a blank
 * white screen.
 */
class ErrorBoundary extends React.Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: unknown) {
    console.error("Unhandled error in render tree:", error);
  }

  render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <Box sx={{ p: 3, maxWidth: 420 }}>
        <Typography variant="h4">Something went wrong</Typography>
        <Typography variant="body1" sx={{ mt: 1, mb: 2, color: "text.secondary" }}>
          The app hit an unexpected error. Reloading usually clears it.
        </Typography>
        <Button variant="contained" sx={{ ml: "15px" }} onClick={() => window.location.reload()}>
          Reload
        </Button>
      </Box>
    );
  }
}

export default ErrorBoundary;
